import colors from "../base/colors";

const { info, white, gradients,text ,background} = colors;
const chip = {
    styleOverrides: {
        root:{
            background:background.default
        },

        label:{
            color:text.main,

        }
    },
}
export default chip;